"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.questionTypeToComponentMapping = void 0;

var _StarsQuestion = require("./StarsQuestion");

var _TextFieldQuestion = require("./TextFieldQuestion");

var _SingleChoiceQuestion = require("./SingleChoiceQuestion");

var _MultipleChoiceQuestion = require("./MultipleChoiceQuestion");

const questionTypeToComponentMapping = {
  Stars: _StarsQuestion.StarsQuestion,
  TextField: _TextFieldQuestion.TextFieldQuestion,
  MultipleChoice: _MultipleChoiceQuestion.MultipleChoiceQuestion,
  SingleChoice: _SingleChoiceQuestion.SingleChoiceQuestion,
  Custom: () => null
};
exports.questionTypeToComponentMapping = questionTypeToComponentMapping;